export default {
  INPUT_TYPES: {
    BUDGET_CATEGORY_INPUT: 'budgetCategoryInput',
    DELETED_INPUT: 'deletedInput',
    RESOLVED_BUG_INPUT: 'resolvedBugInput',
    PAPAS_MERGE_INPUT: 'papasMergeInput',
    SONS_MERGE_INPUT: 'sonsMergeInput',
    ACCOUNT_INPUT: 'accountInput',
    CANCEL_ENVELOPE_INPUT: 'cancelEnvelopeInput',
    ENRICHMENT_INPUT: 'enrichmentInput',
    CHANGE_ENVELOPE_AMOUNT_INPUT: 'changeEnvelopeAmountInput',
    RISEUP_GOAL_INPUT: 'riseupGoalInput',
    ENVELOPE_EXPENSE_CATEGORY_INPUT: 'envelopeExpenseCategoryInput',
  },
  FEATURE_FLAG_NAMES: {
    STORY_MENU: 'story-menu',
    POSITIVE_CHALLENGE_NEW_COPY: 'positive-challenge-new-copy',
    JOIN_AMBASSADORS_INSIGHT: 'elsa-join-ambassadors-insight',
    FIXED_INCOME_USING_ML_MODEL: 'fixed-income-using-ml-model',
    INTERCOM_AB_TEST: 'intercom_ab_test',
    WINE_AND_DINE_SEGMENT_TEST: 'wine-and-dine-segment-test',
    MIGRATION_FROM_PASSWORDS: 'migration-from-passwords',
    SHOW_EDIT_TRACKING_CATEGORY_NAME: 'show_edit_tracking_category_name',
    BALANCE_MONEY_INSIGHT_IN_TRIAL: 'balance-money-insight-trial',
    BALANCE_MONEY_CALCULATOR: 'balance-money-calculator',
    AKIVA_STYLE: 'akiva-style',
    HEVER_BENEFIT_INSIGHT: 'elsa-segment-special-insight',
    EOY_MENU_BANNER: 'eoy-menu-banner',
    INTERCOM_TEMPLATE_MODEL_ROLLOUT: 'template_model_rollout',
    SHOW_MISLAKA_CONSENT_SCREEN: 'show-mislaka-consent-screen',
    NEW_SHORT_TERM_DORMANT: 'new-short-term-dormant',
    FUTURE_CANCELLATION_OFFER: 'future-cancellation-offer',
    PENSION_STORY: 'story-ff-pension_story',
    NO_TRIAL_DISCOUNT: 'no-trial-discount',
    NEW_SUBSCRIPTION_CTA: 'new-subscription-cta',
    SIGNUP_OFFERINGS: 'create-signup-offerings-status',
    SHOW_TRANSACTION_ORIGINAL_AMOUNT: 'show-transaction-original-amount',
    INCOGNITO_MODE_DETECTION: 'incognito-mode-detection',
    OPEN_FOR_EMPLOYEES: 'open-for-employees',
    NEW_CRED_NAME_INPUT: 'elsa-new-cred-name-text',
    SHOW_INSIGHTS_CENTER_INSIGHT: 'show-insights-center-insight',
    PREVENT_POALIM_CLOSED_BANKING: 'prevent-poalim-closed-banking',
    OPEN_MEITAV_OBK: 'open-meitav-obk-connection',
    OPEN_BUDGETZ_OBK: 'open-budgetz-obk-connection',
    SHOW_LEUMI_CHROM_IPHONE_ALERT: 'show-leumi-iphone-chrome-alert',
    NEW_VOUCHERS_FLOW: 'payment-initiation-groceries',
    VIEW_APP_PROMPT: 'view-app-prompt',
    ANNUAL_DISCOUNT_FOR_DORMANTS: 'annual-discount-for-dormants',
    PREVENT_PAYMENTS: 'prevent-payments',
    ACCOUNT_NICKNAME: 'account-nickname',
    SHOW_IBI_INVESTMENTS_PAGE: 'show-ibi-investments-page',
    SHOW_TAX_RETURN_PAGE: 'show-tax-return-page',
    SHOW_MORTGAGE_RESULTS_PAGE: 'show-mortgage-results-page',
    SHOW_100_RAMI_VOUCHER: 'show-100-rami-voucher',
    OPEN_ONE_ZERO: 'open-one-zero',
    BETA_GROUP: 'beta-group',
    SHOW_BETA_GROUP_LOGO: 'show-beta-group-logo',
    SHOW_HACHISHUK: 'show-hachishuk',
    SHOW_MORTGAGE_PAGE: 'show-mortgage-page',
    NEW_APP_BANNER: 'new-app-banner',
    NEW_IOS_APP_BANNER: 'new-ios-app-banner',
    UPLOAD_MORTGAGE_DATA: 'upload-mortgage-report-file',
    EXCLUDED_TOTAL_AMOUNT: 'excluded-total-amount',
    COMMEMT_AND_MOVE_TRANSACTION: 'comment_and_move_transaction',
    EXPENSES_PREDICTED_AMOUNTS: 'expenses-predicted-amounts',
    CUSTOM_SCHEDULE_MESSAGES: 'custom-schedule-messages',
    FUTURE_MONTH_NAVIGATION: 'future-month-navigation',
    PRICE_INCREASE: 'price-increase',
    DAILY_ROUTINE_SETTINGS: 'daily-routine-settings',
    DEVELOPER_TOKENS: 'developer-tokens',
    NEW_MONTHLY_UPGRADE_BUTTON: 'new-monthly-upgrade-button',
    SHOW_NEW_TRACKING_CATEGORY_EDIT: 'show-new-tracking-category-edit',
    BEST_ACTION_FOR_TRANSACTION: 'best-action-for-transaction',
    CASHFLOW_CHATBOT: 'cashflow-chatbot',
    CASHFLOW_CHATBOT_ESCALATION: 'cashflow-chatbot-escalation',
    // Android app kill switches, forwarded to the native host (setAndroidTuning) once the flags load.
    ANDROID_DROP_VARIATIONS_SEED: 'android-webview-drop-variations-seed',
    ANDROID_EAGER_GESTURES: 'android-webview-eager-gestures',
    PUSH_NOTIFICATIONS: 'push-notifications',
    EOY_2025_BADGE: 'eoy2025-badge',
    CASHFLOW_HOME_BILLING: 'cashflow-home-billing',
    AMBASSADORS_COMPETITION_PREVIEW: 'ambassadors-competition-preview',
    CASHFLOW_HOME_BILLING_READ_NEXT_BILLING_DATE: 'cashflow-home-billing-read-next-billing-date',
    CASHFLOW_HOME_BILLING_READ_BENEFITS: 'cashflow-home-billing-read-benefits',
    CHANGE_TRANSACTION_DATE: 'change-transaction-date',
    CX_AGENT_UI_CHANGES: 'cx-agent-ui-changes',
    // Read under the same name by olaf, so routing and UI cannot disagree.
    RISEUP_CHAT_CX_INLINE: 'riseup-chat-cx-inline',
    ONBOARDING_ASSISTANT: 'assistant_onboarding',
    AI_CHAT_CSAT: 'ai-chat-csat',
    ALLOW_UPLOADING_IMAGE_TO_CHATBOT: 'allow-uploading-image-to-chatbot',
    REDESIGN_ENABLED: 'redesign-enabled',
  },
  FEATURE_FLAG_JSON_NAMES: {
    OFFERINGS_EXPERIMENT: 'offerings-experiment',
    PAYMENT_INITIATION_SUPPORTED_BANKS: 'payment-initiation-supported-banks',
  },
  REMOTE_VARIABLES: {
    ISRAEL_BANK_INTEREST: 'israel-bank-interest',
    INFLATION_RATE: 'inflation-rate',
  },
  DYNAMIC_COMPONENT_NAMES: {
    IBI_PAGES: 'ibi_pages',
    TAX_RETURN: 'wintax_pages',
    MORTGAGE_RESULTS: 'mortgages',
    MORTGAGE_FLOW_SELECTOR: 'mortgage_flow_selector',
  },
};
